const data = [
    { id: 1, name: "Deferido" },
    { id: 2, name: "Parcialmente deferido" },
    { id: 3, name: "Indeferido" },
    { id: 4, name: "Extinto" },
    { id: 5, name: "Pendente de julgamento" }
];
  
export default [...data];
  